let _loginFn: (() => void) | null = null

export const registerLoginTrigger = (fn: () => void) => {
    _loginFn = fn
}

export const triggerLogin = () => {
    _loginFn?.()
}
